import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tracking-setup-toggle"
//
// Configure panel's Setup section (card #3613, ADR-0127): Tracking is the
// parent of Insights and Reporting, and also gates Tracking Pattern, Target
// and Chart -- turning Tracking off dims and disables all three sections
// client-side, immediately, no page reload. Objective is deliberately NOT a
// dimSection target -- it stays fully interactive regardless of Tracking's
// state (explicit exception per the card).
//
// This is purely a client-side affordance so a user editing the form sees
// the same parent/child relationship the model now enforces server-side
// (MissionTask#clear_insights_enabled_when_tracking_disabled,
// #clear_report_required_when_tracking_disabled) -- it does not replace
// those validations/callbacks, it just stops the form from suggesting a
// combination the save will silently rewrite.
//
// Unticking Tracking also unchecks any dependent field that's currently
// checked, not just disables it (round 3, card #3613) -- a checked-but-
// disabled box is invisible/confusing even though the browser wouldn't
// submit it anyway. Re-ticking Tracking only re-enables; it does NOT
// restore the old checked state, matching the model callbacks above,
// which are one-way clears too.
export default class extends Controller {
  static targets = ["trackingCheckbox", "dependentField", "dimSection"]

  connect() {
    this.toggle()
  }

  toggle() {
    if (!this.hasTrackingCheckboxTarget) return

    const trackingEnabled = this.trackingCheckboxTarget.checked

    this.dependentFieldTargets.forEach((field) => {
      field.disabled = !trackingEnabled
      if (!trackingEnabled && field.type === "checkbox") {
        field.checked = false
      }
    })

    this.dimSectionTargets.forEach((section) => {
      section.classList.toggle("opacity-50", !trackingEnabled)
      section.querySelectorAll("input, select, textarea, button").forEach((field) => {
        field.disabled = !trackingEnabled
      })
    })
  }
}
